require('../../../modules/es.array.splice');
var entryVirtual = require('../../../internals/entry-virtual');

module.exports = entryVirtual('Array').splice;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/es/array/virtual/splice.js
// module id = 982
// module chunks = 0